import { render, staticRenderFns } from "./EditStartupRegistrationHelp.vue?vue&type=template&id=6a1efc4b&scoped=true"
import script from "./EditStartupRegistrationHelp.vue?vue&type=script&lang=js"
export * from "./EditStartupRegistrationHelp.vue?vue&type=script&lang=js"
import style0 from "./EditStartupRegistrationHelp.vue?vue&type=style&index=0&id=6a1efc4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1efc4b",
  null
  
)

export default component.exports